import { Typography } from 'antd';
import type { TextProps } from 'antd/es/typography/Text';
import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';
import { IComponentSchema } from '../../types';

export interface IFormTextProps extends TextProps {
  text?: string;
  visible?: boolean;
}

const FormText = observer(
  ({ schema }: { schema: IComponentSchema<IFormTextProps> }) => {
    const field = useField<VoidField>();

    const componentProps = {
      ...(schema?.['x-component-props'] || {}),
      ...(field?.componentProps || {}),
    };

    const { text, visible, ...rest } = componentProps as IFormTextProps;

    if (visible === false) return null;

    return <Typography.Text {...rest}>{String(text ?? '')}</Typography.Text>;
  }
);

export default FormText;
